import { useQuery } from '@apollo/client';

import { USER_MATCHES } from '../graphql/query/userMatchesQuery.graphql';

export const useUserMatchesQuery = (eventId: string) => {
  return useQuery(USER_MATCHES, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
